<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<h1>
				{{ "CUSTOMERS_PAGE.MAIN_TITLE" | translate }}
				<div class="section-card-button-container">
					<!-- <app-customer-list-filter></app-customer-list-filter> -->
				</div>
			</h1>
		</mat-card-content>
	</mat-card>
	<app-customers-list expand [showToolsPanel]="true" [customers$]="customers$"></app-customers-list>
</div>
